(($, Drupal, drupalSettings) => {
  function playYoutubeVideo(iframe) {
    const youtubeCommand = window.JSON.stringify({
      event: "command",
      func: "playVideo",
    });

    if (undefined === iframe.contentWindow) {
      return;
    }

    iframe.contentWindow.postMessage(youtubeCommand, iframe.src);
  }

  function playVimeoVideo(iframe) {
    // eslint-disable-next-line no-undef
    const player = new Vimeo.Player(iframe);
    player.play();
  }

  function pauseYoutubeVideo(iframe) {
    const youtubeCommand = window.JSON.stringify({
      event: "command",
      func: "pauseVideo",
    });

    if (undefined === iframe.contentWindow) {
      return;
    }

    iframe.contentWindow.postMessage(youtubeCommand, iframe.src);
  }

  function pauseVimeoVideo(iframe) {
    // eslint-disable-next-line no-undef
    const player = new Vimeo.Player(iframe);
    player.pause();
  }

  /**
   * {inheritdoc}
   */
  Drupal.behaviors.videoParagraphToggle = {
    attach(context, settings) {
      const buttonBucket = [];
      const pauseButtons = once(
        "wwf_video_paragraph_toggle",
        ".video_pause",
        context
      );
      const playButtons = once(
        "wwf_video_paragraph_toggle",
        ".video_play",
        context
      );

      pauseButtons.forEach((element) => {
        const provider = element.getAttribute("provider");
        const elementId = element.getAttribute("video-id");
        const iframe = context.querySelector(`#video-${elementId} iframe`);
        const playButton = context.querySelector(`.play_for_${elementId}`);
        buttonBucket[elementId] = "playing";

        element.addEventListener("click", (event) => {
          // If we add another provider, make this less unwiedly.
          if (buttonBucket[elementId] === "playing" && iframe !== undefined) {
            if (!element.classList.contains("hidden")) {
              element.classList.add("hidden");
            }
            element.setAttribute("aria-hidden", "true");

            if (playButton.classList.contains("hidden")) {
              playButton.classList.remove("hidden");
            }
            playButton.removeAttribute("aria-hidden");

            buttonBucket[elementId] = "paused";

            if (provider === "youtube") {
              pauseYoutubeVideo(iframe);
            } else if (provider === "vimeo") {
              pauseVimeoVideo(iframe);
            }
          }
        });
      });

      playButtons.forEach((element) => {
        const provider = element.getAttribute("provider");
        const elementId = element.getAttribute("video-id");
        const iframe = context.querySelector(`#video-${elementId} iframe`);
        const pauseButton = context.querySelector(`.pause_for_${elementId}`);

        element.addEventListener("click", (event) => {
          // If we add another provider, make this less unwiedly.
          if (buttonBucket[elementId] === "paused" && iframe !== undefined) {
            if (!element.classList.contains("hidden")) {
              element.classList.add("hidden");
            }
            element.setAttribute("aria-hidden", "true");

            if (pauseButton.classList.contains("hidden")) {
              pauseButton.classList.remove("hidden");
            }
            pauseButton.removeAttribute("aria-hidden");

            buttonBucket[elementId] = "playing";

            if (provider === "youtube") {
              playYoutubeVideo(iframe);
            } else if (provider === "vimeo") {
              playVimeoVideo(iframe);
            }
          }
        });
      });
    },
  };
})(jQuery, Drupal, drupalSettings);
